module.exports = __webpack_public_path__ + "static/media/add_request_icon_white.448982e6.png";